import useLoginState from '../../core/hooks/useLoginState';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import useCurrentStockOnlyFlag from '../hooks/useCurrentStockOnlyFlag';
import getMaxOrderableQuantityFromStock from '../util/getMaxOrderableQuantityFromStock';

import useStockAtLocation from './useStockAtLocation';

const useMaxOrderableQuantity = ({
    sku,
    location,
    skip,
}: {
    sku: string;
    location?: string;
    skip?: boolean;
}): {
    maxOrderQuantity: number;
    maxOrderQuantityLoading: boolean;
    maxAvailableOrderQuantity: number;
} => {
    const isLoggedIn = useLoginState();
    const { store } = useStoreAndLanguageParams();
    const currentStockOnly = useCurrentStockOnlyFlag();
    const { stock, futureStock, restriction, loading } = useStockAtLocation({
        sku,
        location,
        skipLoadingStocks: skip,
    });

    if (!isLoggedIn) {
        return {
            maxOrderQuantity: Infinity,
            maxOrderQuantityLoading: loading,
            maxAvailableOrderQuantity: Infinity,
        };
    }

    if (loading || restriction) {
        return {
            maxOrderQuantity: 0,
            maxOrderQuantityLoading: loading,
            maxAvailableOrderQuantity: 0,
        };
    }

    return {
        maxOrderQuantity: getMaxOrderableQuantityFromStock({
            store,
            stock,
            futureStock,
            currentStockOnly,
        }),
        maxOrderQuantityLoading: loading,
        maxAvailableOrderQuantity: stock.quantity ?? 0,
    };
};

export default useMaxOrderableQuantity;
